module.exports = __webpack_public_path__ + "static/img/one.004bb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/one.png
// module id = IrK+
// module chunks = 1